// ─────────────────────────────────────────────────────────
// lib/flags.ts — Feature flag registry
//
// Phase 5: reads from env.ts (single source of truth for
// all env var access). Values are resolved once at startup.
// ─────────────────────────────────────────────────────────
import { ENV } from './env'

function bool(val: string): boolean {
  return val === 'true' || val === '1'
}

export const FLAGS = {
  /**
   * When true: fbLoad / fbSave / fbDel hit the Supabase `docs` table.
   * When false: all operations use IndexedDB only (offline-first).
   * Set VITE_USE_SUPABASE_DB=true to activate.
   */
  USE_SUPABASE_DB: bool(ENV.USE_SUPABASE_DB),

  /**
   * When true: logo and slip-header uploads go to Supabase Storage.
   * When false: files are stored as base64 data URIs inside the brand doc.
   * Set VITE_USE_SUPABASE_STORAGE=true to activate.
   */
  USE_SUPABASE_STORAGE: bool(ENV.USE_SUPABASE_STORAGE),

  /**
   * Migration P5 — Dark mode kill switch.
   * When false: the app is locked to light theme regardless of OS preference
   * or any stored theme value. No toggle is shown to users.
   * Set to true to enable dark mode support when the feature is ready.
   */
  DARK_MODE_ENABLED: false,
} as const

// ── Dev-mode flag reporter ─────────────────────────────────
if (import.meta.env.DEV) {
  if (import.meta.env.DEV) console.info(
    '[CivilBillDesk] Feature flags:',
    Object.entries(FLAGS).map(([k, v]) => `${k}=${v}`).join(', ')
  )
}
